import { Modal } from 'antd';
// import chatttSDK from 'services/chattt';
import { tolgee } from 'services/i18n/tolgee';

export const openExternalURL = async (url: string, target?: string) => {
  if (!url) {
    Modal.error({
      title: tolgee.t('errorMsg.openURLFailTitle'),
      content: tolgee.t('errorMsg.openURLFailMsg'),
    });
  } else {
    window.open(url, target, 'noreferrer=true');
  }
  // if (chatttSDK?.openExternal) {
  //   chatttSDK.openExternal(url).catch((err) => {
  //     if (!url) {
  //       Modal.error({
  //         title: tolgee.t('errorMsg.openURLFailTitle'),
  //         content: tolgee.t('errorMsg.openURLFailMsg'),
  //       });
  //     } else {
  //       Modal.error({
  //         title: tolgee.t('errorMsg.openBrowserTitle'),
  //         content: tolgee.t('errorMsg.openBrowserMsg'),
  //       });
  //     }
  //   });
  // } else {
  //   window.open(url, target);
  // }
};
